import { createGlobalStyle } from "styled-components";

// Sofia fonts (OTF)
import SofiaRegular from "../fonts/Sofia-Pro-Regular.otf";
import SofiaBold from "../fonts/Sofia-Pro-Bold.otf";
import SofiaMedium from "../fonts/Sofia-Pro-Medium.otf";
import SofiaLight from "../fonts/Sofia-Pro-Light.otf";
import SofiaVeryLight from "../fonts/Sofia-Very-Light.otf";

// Ivy fonts (WOFF2)
import IvyRegularWoff2 from "../fonts/IvyMode-Regular.woff2";
import IvyBoldWoff2 from "../fonts/IvyMode-Bold.woff2";
import IvySemiBoldWoff2 from "../fonts/IvyMode-SemiBold.woff2";
import IvyLightWoff2 from "../fonts/IvyMode-Light.woff2";
import IvyThinWoff2 from "../fonts/IvyMode-Thin.woff2";

const GlobalStyles = createGlobalStyle`
  /* Sofia Font Family */
  @font-face {
    font-family: Sofia;
    src: url(${SofiaRegular}) format('opentype');
    font-weight: 400;
    font-display: optional;
    size-adjust: 100%;
  }

  @font-face {
    font-family: Sofia;
    src: url(${SofiaBold}) format('opentype');
    font-weight: 800;
    font-display: optional;
    size-adjust: 100%;
  }

  @font-face {
    font-family: Sofia;
    src: url(${SofiaMedium}) format('opentype');
    font-weight: 500;
    font-display: optional;
    size-adjust: 100%;
  }

  @font-face {
    font-family: Sofia;
    src: url(${SofiaLight}) format('opentype');
    font-weight: 300;
    font-display: optional;
    size-adjust: 100%;
  }

  @font-face {
    font-family: Sofia;
    src: url(${SofiaVeryLight}) format('opentype');
    font-weight: 100;
    font-display: optional;
    size-adjust: 100%;
  }

  /* Ivy Font Family - WOFF2 */
  @font-face {
    font-family: Ivy;
    src: url(${IvyRegularWoff2}) format('woff2');
    font-weight: 400;
    font-display: optional;
    size-adjust: 100%;
  }

  @font-face {
    font-family: Ivy;
    src: url(${IvyBoldWoff2}) format('woff2');
    font-weight: 800;
    font-display: optional;
    size-adjust: 100%;
  }

  @font-face {
    font-family: Ivy;
    src: url(${IvySemiBoldWoff2}) format('woff2');
    font-weight: 500;
    font-display: optional;
    size-adjust: 100%;
  }

  @font-face {
    font-family: Ivy;
    src: url(${IvyLightWoff2}) format('woff2');
    font-weight: 300;
    font-display: optional;
    size-adjust: 100%;
  }

  @font-face {
    font-family: Ivy;
    src: url(${IvyThinWoff2}) format('woff2');
    font-weight: 100;
    font-display: optional;
    size-adjust: 100%;
  }


  body {
    /* Fixed navbar padding: UpperNav (39px) + NewNavbar (114px) = 153px on desktop, 80px on mobile */
    padding-top: 153px;
  }

  /* Ensure all text elements inherit proper font stacks */
  /* * {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  } */

  /* Base HTML and Body styles */
  html,
  body {
    max-width: 100%;
  }

  html {
    font-size: clamp(6px, 0.8vw, 14px);
  }

  /* Mobile navbar padding adjustment */
  @media (max-width: 768px) {
    body {
      padding-top: 80px;
    }
  }

  /* Component-specific global styles */
  .infinite-scroll-component {
    overflow: hidden !important;
  }

  .switch-wrapper {
    position: relative;
  }

  .switch-wrapper > div {
    position: relative;
    z-index: 1;
  }
`;

export default GlobalStyles;
